<template>
  <div class="dashboard-widget-content">
    <template v-if="!value.ShowOptions">
      <chart-card-dashboard-wings no-footer :data="ChartData">
        <pie-chart :data="ChartData"></pie-chart>
      </chart-card-dashboard-wings>
    </template>
    <template v-else>
      <widget-options>
        <md-field>
          <label>{{ $t('widget.options.update') }}</label>
          <md-select v-model="options.update">
            <md-option value="10">10 мин</md-option>
            <md-option value="0">Нет</md-option>
          </md-select>
        </md-field>
        <md-field>
          <label>{{ $t('widget.options.interval') }}</label>
          <md-select v-model="options.interval">
            <md-option value="hour">предыдущий час</md-option>
            <md-option value="today">сегодня</md-option>
            <md-option value="yesterday">вчера</md-option>
          </md-select>
        </md-field>
        <md-field>
          <label>{{ $t('widget.options.chanel') }}</label>
          <md-select v-model="options.chanel">
            <md-option v-for="transport in this.$store.getters.transports" :value="transport.name" :key="transport.id">
              {{ transport.name }}
            </md-option>
          </md-select>
        </md-field>
        <md-field>
          <label>{{ $t('widget.options.statuses') }}</label>
          <md-select v-model="options.statuses" multiple>
            <md-option v-for="(status, idx) in getStatuses" :value="status" :key="idx">
              {{ $t('widget.statuses.'+status) }}
            </md-option>
          </md-select>
        </md-field>
      </widget-options>
    </template>
  </div>
</template>

<script>
import widgetMixin from './mixin'
import { DateTime } from 'luxon'
import {MessageStatuses} from "@/services/Widgets";

export default {
  name: "MessageStatuses",
  mixins:[widgetMixin],
  props:{
    value:{},
    fullSize:{default:false}
  },
  data(){return{
    options:{
      update:'10',
      interval:'hour',
      chanel:'SMS',
      date_from: '',
      date_to: '',
      statuses: [],
    },
    ChartData: [],
    statusList: {
      SMS:[
        'deferred',
        'delivered',
        'expired',
        'failed',
        'not_delivered',
        'rejected',
        'transmitted',
      ],
      Call: [
        'buffered',
        'error',
        'finished',
        'not_answered',
        'rejected',
      ],
      Email: [
        'deferred',
        'delivered',
        'failed',
        'not_delivered',
        'read',
        'rejected',
        'transmitted',
      ],
      Viber: [
        'deferred',
        'delivered',
        'expired',
        'failed',
        'not_delivered',
        'read',
        'rejected',
        'transmitted',
      ],
      Push: [
        'deferred',
        'delivered',
        'expired',
        'failed',
        'not_delivered',
        'read',
        'rejected',
        'transmitted',
      ],
      WhatsApp: [
        'deferred',
        'delivered',
        'expired',
        'failed',
        'not_delivered',
        'read',
        'rejected',
        'transmitted',
      ]
    }
  }},
  computed: {
    getStatuses() {
      return this.statusList[this.options.chanel];
    },
  },
  methods:{
    title(){
      let title = this.$t('widget.MessageStatuses.title')+' ('+this.options.chanel+')';

      switch (this.options.interval) {
        case 'hour':
          title += ' с ' + DateTime.fromISO(this.options.date_from).toFormat('HH:mm');
          title += ' до ' + DateTime.fromISO(this.options.date_to).toFormat('HH:mm');
          break;
        case 'today':
          title += ' сегодня';
          break;
        case 'yesterday':
          title += ' вчера';
          break;
      }
      return title;
    },
    async getData() {
      switch (this.options.interval) {
        case 'hour':
          this.options.date_from = DateTime.local().plus({hour:-1}).toISO();
          this.options.date_to = DateTime.local().toISO();
          break;
        case 'today':
          this.options.date_from = DateTime.local().set({hour: 0, minute: 0, second: 0, millisecond: 0}).toISO();
          this.options.date_to = DateTime.local().set({second: 0, millisecond: 0}).toISO();
          break;
        case 'yesterday':
          this.options.date_from = DateTime.local().set({hour: 0, minute: 0, second: 0, millisecond: 0}).plus({day: -1}).toISO();
          this.options.date_to = DateTime.local().set({hour: 0, minute: 0, second: 0, millisecond: 0}).toISO();
          break;
      }

      let filter = {
        date_from: this.options.date_from,
        date_to: this.options.date_to,
        transport: this.options.chanel,
        statuses: this.options.statuses,
      };

      let response = await MessageStatuses(filter);
      // response.data = {
      //     "transmitted" : 1,
      //     "delivered" : 1,
      //     "not_delivered" : 1,
      //     "expired" : 1,
      //     "failed" : 1,
      //     "rejected" : 1,
      //     "deferred" : 1,
      //     "total" : 12,
      // }
      if (response.data) {
        let chartData = [];

        Object.entries(response.data).forEach(([key, value]) => {
          if (value && key != 'total') {
            chartData.push({
              name: this.$t('widget.statuses.'+key),
              value: value,
            });
          }
        });

        this.ChartData = chartData;
      }

      this.updateTitle();
    },
    intervalFunc() {
      clearInterval(this.timer);
      const update = (60000 * parseInt(this.options.update)) || 0;
      if (update > 0) {
        this.getData();
        this.timer = setInterval(() => this.getData(), update);
      }
    }
  },
  watch: {
    'options'() {
      this.intervalFunc();
    },
    'options.chanel'(val) {
      this.options.statuses = [];
    }
  },
  mounted() {
    this.intervalFunc();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
}
</script>
